module.exports = "https://99designs-start-assets.imgix.net/js/e1dbe40b96fea67c82e93f173ca814c1.png";